import { ApiParameter, doesNotHaveExpand, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { QuoteType } from "@insite/client-framework/Services/QuoteService";
import { QuoteCollectionModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";

export interface GetQuotesApiParameter extends ApiParameter, HasPagingParameters {
  /**
   * @deprecated Use userId instead
   */
  userProfileId?: string;
  userId?: string;
  salesRepNumber?: string;
  customerId?: string;
  statuses?: string[];
  quoteNumber?: string;
  fromDate?: string;
  toDate?: string;
  expireFromDate?: string;
  expireToDate?: string;
  types?: QuoteType;
  expand?: "salesList"[];
  isQuote?: boolean;
  customerSequence?: number;
}

const quotesUrl = "/api/v1/orders";

function cleanQuoteCollection(quoteCollection: QuoteCollectionModel, parameter?: { expand?: string[] }) {
  if (doesNotHaveExpand(parameter, "salesList")) {
      quoteCollection.salespersonList = null;
  }
}

function cleanQuote(quote: QuoteModel) {
  quote.orderDate = quote.orderDate ? new Date(quote.orderDate) : null;
  quote.expirationDate = quote.expirationDate ? new Date(quote.expirationDate) : null;
  quote.cartLines = quote.quoteLineCollection;
  quote.messageCollection?.forEach(message => {
      if (message.createdDate) {
          message.createdDate = new Date(message.createdDate);
      }
  });
}

export async function getQuotes(getQuotesParameter: GetQuotesApiParameter) {
    getQuotesParameter.isQuote = true;
    getQuotesParameter.customerSequence = -1;
    const quotes = await get<any>(quotesUrl, getQuotesParameter);
    cleanQuoteCollection(quotes, getQuotesParameter);
    quotes.orders?.forEach(cleanQuote);
    return {
        ...quotes,
        quotes: quotes.orders?.map((o: any) => o as QuoteModel),
    } as QuoteCollectionModel;
}
